// src/components/ProductCard.tsx

import React, { useState, useEffect, useRef } from 'react';
import { Product } from '../utils/types'; // Ensure this is the correct path to your types
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';
import ProductOptionsModal from './ProductOptionsModal'; // Import the modal component
import { displayPrice } from '../utils/general';
import { useSettings } from '../context/SettingsContext';
import { FaCircle } from "react-icons/fa";
import { useCart } from '../context/CartContext';

interface ProductCardProps {
    product: Product;
    isInCart: boolean;
    vendorId: number; // Add vendorId prop
}

const ProductCard: React.FC<ProductCardProps> = ({ product, isInCart, vendorId }) => {
    const { settings } = useSettings();
    const { cartItems } = useCart();

    // const [ref, inView] = useInView({ threshold: 0.1 });

    // Animation for flipping effect
    // const props = useSpring({
    //     transform: inView ? 'rotateY(0deg)' : 'rotateY(180deg)',
    //     config: { tension: 300, friction: 20 },
    // });

    const [modalOpen, setModalOpen] = useState(false); // State for modal visibility
    // const [quantity, setQuantity] = useState<number>(1); // Add quantity state

    // const handleQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const value = parseInt(e.target.value);
    //     setQuantity(value > 0 ? value : 1); // Ensure quantity is at least 1
    // };

    // console.table(settings);

    const divRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = product.image_path || '../images/df.png';

        img.onload = () => {

            // console.log('Image loaded:', img.src);
            if (divRef.current) {
                divRef.current.style.backgroundImage = `url(${img.src})`;
            }
        };
    }, [product.image_path]);

    const truncateText = (text: string, maxLength: number): string =>
        text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;


    // Find the cart item for this product
    const cartItem = cartItems.find((item) => item.productId === product.id);
    const totalQuantity = cartItems
        .filter((item) => item.productId === product.id && !item.checkedOut)
        // .filter((item) => item.productId === product.id)
        .reduce((sum, item) => sum + item.quantity, 0);

    const totalQuantityCO = cartItems
        .filter((item) => item.productId === product.id && item.checkedOut)
        .reduce((sum, item) => sum + item.quantity, 0);

    // Check if the product is in the cart and get its quantity
    // const isInCart = !!cartItem;
    const itemQuantity = cartItem?.quantity || 0;
    // console.log('cartItotalQuantitytem', cartItems, cartItem, itemQuantity);

    const handleAddToCart = () => {
        const existingCartItem = cartItems.find((item) => item.productId === product.id && !item.checkedOut);
        const hasOptions = product.add_ons || product.toppings || product.options;

        if (existingCartItem && !hasOptions) {
            // Update the existing item in the cart
            // Pass the existing cart item to the modal for editing
            setModalOpen(true);
        } else {
            // Add a new item to the cart or handle products with options
            setModalOpen(true);
        }
    };

    const existingCartItem = cartItems.find((item) => item.productId === product.id && !item.checkedOut);
    
    // console.log('existingCartItem', existingCartItem);
    // console.log('product', product);
    
    return (
        // <div className="w-28 md:w-36 border border-1 rounded-xl m-1 p-1 shadow-md  text-center place-items-center bg-cover" style={{ borderColor: '#7a75b5', backgroundColor: '#f5f5f5', backgroundImage: `url(${product.image_path && product.image_path.length > 0 ? product.image_path : '../images/df.png'})` }}>
        <div
            ref={divRef}
            className={`w-32 md:w-36 lg:w-28   h-32 md:h-36 lg:h-28 border border-1 rounded-xl m-1 p-0 shadow-md text-center grid grid-col  content-end   place-items-center bg-cover 
                ${isInCart ? 'border-yellow-400 relative' : 'border-gray-200'} 
                `}
            style={{
                backgroundColor: '#f5f5f5',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
            onClick={handleAddToCart} // Call the function to handle adding to cart
        >

            {isInCart && (
                <div className='absolute -top-2 -right-2 z-10 text-red-400 p-0'>

                    {totalQuantity > 0 && (
                        <>
                            <div className='absolute -top-1 right-0 z-20 text-red-500 p-1 text-lg font-bold'>
                                <FaCircle size={28} color={'#ffdd59'} />
                                <div className='absolute top-0 left-0 w-full h-full flex items-center justify-center text-black'>
                                    {totalQuantity}
                                </div>
                            </div>
                        </>
                    )}

                    {totalQuantityCO > 0 && (
                        <>

                            <div className='absolute top-6 right-0 z-20 text-red-500 p-1 text-lg font-bold'>
                                <FaCircle size={28} color={'#cedd99'} />
                                <div className='absolute top-0 left-0 w-full h-full flex items-center justify-center text-black'>
                                    {totalQuantityCO}
                                </div>
                            </div>
                        </>
                    )}

                </div>
            )}


            {/* <div className="w-28 md:w-36 h-28 md:h-36 rounded m-0 p-1 ">
                <div className="flex justify-center " onClick={() => setModalOpen(true)}
                >
                    <img
                        src={product.image_path && product.image_path.length > 0 ? product.image_path : '../images/df.png'}
                        alt={product.name}
                        crossOrigin="anonymous"
                        // className="flex items-center space-x-4 bg-gray-100 p-3 rounded-full"
                        className="h-16 md:h-32 object-cover rounded-full"

                    />
                </div>
            </div> */}

            <div className='w-full m-0 p-0'>
                <h3 className="text-sm md:text-md font-bold break-words bg-white bg-opacity-90 m-0 p-1">
                    {truncateText(product.name, 20)}
                    {/* {!!existingCartItem || !product.add_ons || !product.toppings || !product.options} */}

                    {/* {existingCartItem && (
                        <span className="text-xs text-red-500"> (existingCartItem)</span>
                    )} */}

                    {/* {product.add_ons.length > 2 && (
                        <span className="text-xs text-red-500">ao {product.add_ons.length}</span>
                    )}
                    {product.toppings.length > 2 && (
                        <span className="text-xs text-red-500">tp {product.toppings.length}</span>
                    )} */}
                    {/* {existingCartItem?.options.specifications.length && (
                        <span className="text-xs text-red-500">opt {existingCartItem?.options}</span>
                    )} */}
                </h3>
                {/* <p className="text-gray-600">{product.description}</p> */}
            </div>
            {product.description && (
                <div className='w-full m-0 p-0'>
                    <h3 className="text-sm md:text-md font-bold break-words bg-white bg-opacity-90 m-0 p-1">{truncateText(product.description, 20)}</h3>
                    {/* <p className="text-gray-600">{product.description}</p> */}
                </div>
            )}
            <p className="w-full text-md font-semibold bg-white bg-opacity-90 m-0 p-1">{settings?.currencyName}{displayPrice(product.price)}</p>

            {/* Quantity input */}
            {/* <input
                type="number"
                value={quantity}
                min="1"
                onChange={handleQuantityChange}
                className="border rounded p-1 w-16"
            /> */}

            {/* <button
                onClick={() => setModalOpen(true)}
                className="mt-2 bg-blue-500 text-white py-1 px-3 rounded"
            >
                Choose
            </button> */}

            {/* Modal for selecting options */}
            <ProductOptionsModal
                product={product}
                vendorId={vendorId}
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                initialQuantity={existingCartItem ? existingCartItem.quantity : 1} // Pass existing quantity if editing
                cartItem={existingCartItem} // Pass the existing cart item if it exists
                isEditMode={!!existingCartItem} // Set edit mode if the item exists in the cart and has no options
                fromCart={false} // Enable edit mode if from Cart

                // || (!product.add_ons && !product.toppings && !product.options)
                //  || product.add_ons|| product.toppings//  && !(product.add_ons?.length || product.toppings?.length || product.options?.length)
            />
        </div>
    );
};

export default ProductCard;